import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useSite } from "../context/SiteContext";
import { WhatsAppIcon } from "./Hero";

export default function FloatingWhatsApp() {
    const { content, t } = useSite();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 450);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const waLink = `https://wa.me/${content?.whatsapp || ""}?text=${encodeURIComponent(
        t.wa.hero.replace("{name}", content?.business_name || "J&S Beauty Studio")
    )}`;

    return (
        <AnimatePresence>
            {visible && (
                <motion.a
                    href={waLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="floating-whatsapp"
                    initial={{ opacity: 0, scale: 0.6, y: 20 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.6, y: 20 }}
                    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                    className="fixed bottom-6 right-6 z-[60] group"
                    aria-label={t.whatsappAria}
                >
                    <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" aria-hidden="true" />
                    <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.4)] group-hover:scale-110 transition-transform duration-300">
                        <WhatsAppIcon size={26} />
                    </span>
                </motion.a>
            )}
        </AnimatePresence>
    );
}
